/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

export const GDPR_COOKIES_POPUP_ID = 'gdpr_cookies';
export const GDPR_COOKIES_ACCEPTED = 'gdpr_cookies_accept_ext';
